<template>
  <div id="overview-service-tab">
    <div>
      <v-container class="content-wrapper" fluid>
        <v-row justify="center" align="center">
          <v-col cols="12" lg="10">
            <v-card
              class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
              elevation="3"
              style="border-radius: 24px;"
            >
              <!-- Back to the Service -->
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="auto">
                    <v-btn
                      depressed
                      rounded
                      small
                      color="blue"
                      class="white--text font-weight-bold"
                      @click="goBack"
                    >
                      <v-icon color="black" small class="mr-2">
                        mdi-arrow-left
                      </v-icon>
                      Back
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
              <!-- Logo Hosting and Logo Service -->
              <v-card-text>
                <v-row align="center" justify="start">
                  <v-col cols="12" md="6" sm="6" lg="6" xl="6">
                    <v-img
                      :src="service.logoUrlPublic"
                      class="resource-image"
                      lazy-src="@/assets/img/blur.jpg"
                      contain
                      style="max-width: 200px; border-radius: 19.875px;"
                    ></v-img>
                    <!-- <v-card-text class="mt-5">
                      <v-icon>mdi-eye</v-icon>
                      {{ service.views }} registered views
                    </v-card-text>
                    <v-card-text class="pt-0">
                      <v-icon>mdi-eye</v-icon>
                      {{ service.nonRegisteredViews }} non registered views
                    </v-card-text> -->
                  </v-col>
                  <v-col cols="12" md="6" sm="6" lg="6" xl="6" class="d-flex justify-end">
                    <v-img
                      v-if="service.picture"
                      :src="service.picture"
                      class="resource-image"
                      lazy-src="@/assets/img/blur.jpg"
                      contain
                      style="width: 100%; max-width: 350px; max-height: 100%; border-radius: 19.875px;"
                    ></v-img>
                  </v-col>
                </v-row>
              </v-card-text>

              <!--  Main Body-->
              <v-card-text>
                <v-row align="center" no-gutters>
                  <v-col cols="auto">
                    <h2 class="black--text">
                      {{ service.name }}
                    </h2>
                  </v-col>
                  <v-col cols="auto" class="mx-4">
                    <v-btn @click.stop="modalLogIn = true" elevation="2" icon raised medium>
                      <v-icon>mdi-heart-outline</v-icon>
                    </v-btn>
                  </v-col>
                  <!-- <v-col>
                    <v-btn @click.stop="modalLogIn = true" elevation="2" icon raised medium>
                      <v-icon>mdi-email-outline</v-icon>
                    </v-btn>
                  </v-col> -->
                </v-row>
              </v-card-text>
              <v-card-text class="pt-0">
                <v-chip flat label medium color="blue" class="white--text font-weight-bold">
                  Service
                </v-chip>
              </v-card-text>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6" sm="12">
                    <h3 class="primary200--text">
                      Description
                    </h3>
                    <div v-html="service.description"></div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text v-if="service.provider && service.provider.id && service.provider.name">
                <v-row>
                  <v-col cols="12" md="6" sm="12">
                    <h3 class="primary200--text">
                      Provider:
                    </h3>
                    <template v-if="service && service.provider && service.provider.id">
                      <router-link
                        :to="{
                          name: 'PublicOverviewProvider',
                          params: { id: service.provider.id },
                        }"
                        style="text-decoration: underline; color: inherit;"
                      >
                        {{ service.provider.name }}
                      </router-link>
                    </template>
                    <template v-else>
                      <span>No provider available</span>
                    </template>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text
                v-if="
                  service.provider.hostingInstitution &&
                    service.provider.hostingInstitution.name &&
                    service.provider.hostingInstitution.id
                "
              >
                <v-row>
                  <v-col cols="12" md="6" sm="12">
                    <h3 class="primary200--text">
                      Hosting Institution Entity:
                    </h3>
                    <router-link
                      :to="{
                        name: 'PublicOverviewHostingInstitution',
                        params: { id: service.provider.hostingInstitution.id },
                      }"
                      style="text-decoration: underline; color: inherit;"
                    >
                      {{ service.provider.hostingInstitution.name }}
                    </router-link>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text v-if="service.tags.length">
                <v-row>
                  <v-col cols="12" md="6" sm="12">
                    <h3 class="primary200--text">
                      Tags
                    </h3>
                  </v-col>
                </v-row>
                <v-row v-if="service.tags.length > 0">
                  <v-chip
                    :color="color(index)"
                    v-for="(tag, index) in service.tags"
                    :key="index"
                    class="ma-2"
                  >
                    {{ tag }}
                  </v-chip>
                </v-row>
              </v-card-text>
              <v-card-text class="mt-5">
                <v-row>
                  <v-col cols="2">
                    <v-btn
                      @click.stop="modalLogIn = true"
                      block
                      depressed
                      rounded
                      large
                      color="primary200"
                      class="white--text font-weight-bold"
                    >
                      <v-icon color="white" class="mr-2">mdi-cart-outline</v-icon>
                      {{ !ordersPending ? 'Order Request' : 'Order Status' }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>

              <!-- Overview Service Tabs -->
              <v-card-text>
                <v-tabs v-model="tab" show-arrows active-class="primary200--text">
                  <v-tabs-slider color="primary200"></v-tabs-slider>
                  <v-tab v-if="basicInfoTab">{{ $t('basic') }}</v-tab>
                  <v-tab v-if="classificationTab">{{ $t('classification') }}</v-tab>
                  <!-- <v-tab v-if="contactTab">{{ $t('contact') }}</v-tab> -->
                  <v-tab v-if="managementTab">{{ $t('management') }}</v-tab>
                  <v-tab v-if="pricingTab">{{ $t('pricing') }}</v-tab>
                  <v-tab v-if="additionalInfoTab">{{ $t('additional-information') }}</v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                  <!-- Basic Info -->
                  <v-tab-item
                    v-if="basicInfoTab"
                    :transition="false"
                    :reverse-transition="false"
                    :key="0"
                  >
                    <v-row class="mt-10">
                      <v-col v-if="service.basicInfo.prerequisites" cols="12" md="2" sm="12">
                        <label>Prerequisites</label>
                        <div v-html="service.basicInfo.prerequisites"></div>
                      </v-col>
                      <v-col v-if="service.basicInfo.webpage" cols="12" md="2" sm="12">
                        <label>Webpage</label>
                        <p>
                          {{ service.basicInfo.webpage }}
                        </p>
                      </v-col>
                    </v-row>
                    <v-row class="mt-0 pt-0">
                      <v-col v-if="service.basicInfo.tagline" cols="12" md="2" sm="12">
                        <label>Tagline</label>
                        <p>
                          {{ service.basicInfo.tagline }}
                        </p>
                      </v-col>
                      <v-col v-if="service.basicInfo.useCases.length" cols="12" md="2" sm="12">
                        <label>Use Case</label>
                        <p>
                          <span v-for="(useCase, index) in service.basicInfo.useCases" :key="index">
                            {{ useCase.text }}
                            <span v-if="index < service.basicInfo.useCases.length - 1">, </span>
                          </span>
                        </p>
                      </v-col>
                    </v-row>
                  </v-tab-item>

                  <!-- Classification Info -->
                  <v-tab-item
                    v-if="classificationTab"
                    :transition="false"
                    :reverse-transition="false"
                    :key="1"
                  >
                    <v-row v-if="service.classificationInfo.domains.length" class="mt-10">
                      <v-col cols="12" md="2" sm="12">
                        <label v-if="service.classificationInfo.domains.length > 1"
                          >Scientific domains</label
                        >
                        <label v-else>Scientific Domain</label>
                        <p>
                          <span
                            v-for="(domain, index) in service.classificationInfo.domains"
                            :key="index"
                          >
                            {{ domain.domain }}
                            <span v-if="index < service.classificationInfo.domains.length - 1"
                              >,
                            </span>
                          </span>
                        </p>
                      </v-col>
                      <v-col cols="12" md="2" sm="12">
                        <label v-if="service.classificationInfo.domains.length > 1"
                          >Scientific Subdomains</label
                        >
                        <label v-else>Scientific Subdomain</label>
                        <p>
                          <span
                            v-for="(subdomain, index) in service.classificationInfo.domains"
                            :key="index"
                          >
                            {{ subdomain.subDomain }}
                            <span v-if="index < service.classificationInfo.domains.length - 1"
                              >,
                            </span>
                          </span>
                        </p>
                      </v-col>
                    </v-row>
                    <v-row v-if="service.classificationInfo.categories.length" class="mt-0 pt-0">
                      <v-col cols="12" md="2" sm="12">
                        <label v-if="service.classificationInfo.categories.length > 1"
                          >Categories</label
                        >
                        <label v-else>Category</label>
                        <p>
                          <span
                            v-for="(category, index) in service.classificationInfo.categories"
                            :key="index"
                          >
                            {{ category.category }}
                            <span v-if="index < service.classificationInfo.categories.length - 1"
                              >,
                            </span>
                          </span>
                        </p>
                      </v-col>
                      <v-col cols="12" md="2" sm="12">
                        <label v-if="service.classificationInfo.categories.length > 1"
                          >Subcategories</label
                        >
                        <label v-else>Subcategory</label>
                        <p>
                          <span
                            v-for="(subcategory, index) in service.classificationInfo.categories"
                            :key="index"
                          >
                            {{ subcategory.subCategory }}
                            <span v-if="index < service.classificationInfo.categories.length - 1"
                              >,
                            </span>
                          </span>
                        </p>
                      </v-col>
                    </v-row>
                    <v-row class="mt-0 pt-0">
                      <v-col
                        v-if="service.classificationInfo.accessModes.length"
                        cols="12"
                        md="2"
                        sm="12"
                      >
                        <label v-if="service.classificationInfo.accessModes.length > 1"
                          >Access Modes</label
                        >
                        <label v-else>Access Mode</label>
                        <p>
                          <span v-if="service.classificationInfo.accessModes.length === 0">-</span>
                          <span
                            v-else
                            v-for="(mode, index) in service.classificationInfo.accessModes"
                            :key="index"
                          >
                            {{ mode.name }}
                            <span v-if="index < service.classificationInfo.accessModes.length - 1"
                              >,
                            </span>
                          </span>
                        </p>
                      </v-col>
                      <v-col
                        v-if="service.classificationInfo.accessTypes.length"
                        cols="12"
                        md="2"
                        sm="12"
                      >
                        <label v-if="service.classificationInfo.accessTypes.length > 1"
                          >Access Types</label
                        >
                        <label v-else>Access Type</label>
                        <p>
                          <span v-if="service.classificationInfo.accessTypes.length === 0">-</span>
                          <span
                            v-else
                            v-for="(type, index) in service.classificationInfo.accessTypes"
                            :key="index"
                          >
                            {{ type.name }}
                            <span v-if="index < service.classificationInfo.accessTypes.length - 1"
                              >,
                            </span>
                          </span>
                        </p>
                      </v-col>
                    </v-row>
                    <v-row v-if="service.classificationInfo.targetUsers.length" class="mt-0 pt-0">
                      <v-col cols="12" md="6" sm="12">
                        <label v-if="service.classificationInfo.targetUsers.length > 1"
                          >Target Users</label
                        >
                        <label v-else>Targer User</label>
                        <p>
                          <span v-if="service.classificationInfo.targetUsers.length === 0">-</span>
                          <span
                            v-else
                            v-for="(user, index) in service.classificationInfo.targetUsers"
                            :key="index"
                          >
                            {{ user.name }}
                            <span v-if="index < service.classificationInfo.targetUsers.length - 1"
                              >,
                            </span>
                          </span>
                        </p>
                      </v-col>
                    </v-row>
                  </v-tab-item>

                  <!-- Contact Info -->
                  <!-- <v-tab-item
                    v-if="contactTab"
                    :transition="false"
                    :reverse-transition="false"
                    :key="2"
                  >
                    <v-row>
                      <v-col cols="12" lg="5" xl="4" md="6" sm="12">
                        <v-card class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6 custom-card">
                          <v-row align="center">
                            <v-col cols="12" lg="3" xl="3" md="12" sm="12">
                              <v-card-text style="filter: blur(3px);">
                                <v-avatar
                                  :size="80"
                                  class="white--text text-bold"
                                  :color="'primary'"
                                >
                                  {{ letters }}
                                </v-avatar>
                              </v-card-text>
                            </v-col>
                            <v-col cols="12" lg="9" xl="9" md="12" sm="12">
                              <v-card-title
                                class="black--text text-bold"
                                style="filter: blur(4px);"
                              >
                                {{ service.contactInfo.lastname }}
                                {{ service.contactInfo.firstname }}
                              </v-card-title>
                              <v-card-text
                                class="mt-0 pt-0 primary200--text text-bold"
                                style="filter: blur(3px);"
                              >
                                {{ service.contactInfo.email }}
                              </v-card-text>
                              <v-card-text
                                class="mt-0 pt-0 primary200--text text-bold"
                                style="filter: blur(3px);"
                              >
                                {{ service.contactInfo.phone }}
                              </v-card-text>
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-tab-item> -->

                  <!-- Management Info -->
                  <v-tab-item
                    v-if="managementTab"
                    :transition="false"
                    :reverse-transition="false"
                    :key="3"
                  >
                    <v-row class="mt-10">
                      <v-col cols="12" md="6" sm="12">
                        <label>Service Level</label>
                        <p>
                          <a
                            @click="handleServiceLevelClick"
                            style="text-decoration: underline; color: inherit;"
                          >
                            {{ service.managementInfo.serviceLevel }}
                          </a>
                        </p>
                      </v-col>
                    </v-row>
                  </v-tab-item>

                  <!-- Pricing Info -->
                  <v-tab-item
                    v-if="pricingTab"
                    :transition="false"
                    :reverse-transition="false"
                    :key="4"
                  >
                    <v-row class="mt-10">
                      <v-col cols="12" md="6" sm="12">
                        <label>Payment Model</label>
                        <p>
                          {{ service.pricingInfo.paymentModel }}
                        </p>
                      </v-col>
                    </v-row>
                    <v-row class="mt-0 pt-0">
                      <v-col cols="12" md="6" sm="12">
                        <label>Pricing</label>
                        <p>
                          {{ service.pricingInfo.pricing }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-tab-item>

                  <!-- Additional Info -->
                  <v-tab-item
                    v-if="additionalInfoTab"
                    :transition="false"
                    :reverse-transition="false"
                    :key="5"
                  >
                    <v-row v-if="service.additionalInfo.helpDeskEmail" class="mt-10">
                      <v-col cols="12" md="6" sm="12">
                        <label>Help Desk</label>
                        <p>
                          {{ service.additionalInfo.helpDeskEmail }}
                        </p>
                      </v-col>
                    </v-row>
                    <v-row v-if="service.additionalInfo.standards.length" class="mt-0 pt-0">
                      <v-col cols="12" md="6" sm="12">
                        <label>Standards</label>
                        <p>
                          <span>
                            <span
                              v-for="(standard, index) in service.additionalInfo.standards"
                              :key="index"
                            >
                              {{ standard }}
                              <span v-if="index < service.additionalInfo.standards.length - 1"
                                >,
                              </span>
                            </span>
                          </span>
                        </p>
                      </v-col>
                    </v-row>
                    <v-row v-if="service.additionalInfo.userManual" class="mt-0 pt-0">
                      <v-col cols="12" md="6" sm="12">
                        <label>User Manual</label>
                        <p>
                          <v-btn
                            :disabled="!$store.getters.roles"
                            v-if="service.additionalInfo.userManual"
                            @click="downloadUserManual(service.additionalInfo.userManual)"
                            icon
                            raised
                            small
                          >
                            <v-icon>mdi-file-pdf-box</v-icon>
                          </v-btn>
                          {{ service.additionalInfo.userManual }}
                        </p>
                      </v-col>
                    </v-row>
                    <v-row v-if="service.additionalInfo.termsOfUse" class="mt-0 pt-0">
                      <v-col cols="12" md="6" sm="12">
                        <label>Terms of use</label>
                        <p>
                          <v-btn
                            :disabled="!$store.getters.roles"
                            v-if="service.additionalInfo.termsOfUse"
                            @click="downloadTermsOfUse(service.additionalInfo.termsOfUse)"
                            icon
                            raised
                            small
                          >
                            <v-icon>mdi-file-pdf-box</v-icon>
                          </v-btn>
                          {{ service.additionalInfo.termsOfUse }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs-items>
              </v-card-text>
            </v-card>

            <!-- Other Resources -->
            <v-card
              v-if="paginatedResources.length"
              class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
              elevation="3"
              style="border-radius: 24px;"
            >
              <v-card-title class="black--text mt-0 pt-0">
                <v-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  class="d-flex align-center justify-center justify-md-start justify-xl-start justify-lg-start mt-0 pt-0"
                >
                  Other Resources
                </v-col>
                <v-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  class="d-flex justify-center justify-md-end justify-xl-end justify-lg-end align-center mt-0 pt-0"
                >
                  <v-btn :disabled="currentPage === 1" @click="currentPage--" small plain>
                    <v-icon color="black" small class="mr-2">
                      mdi-arrow-left
                    </v-icon>
                  </v-btn>
                  <span> {{ currentPage }} / {{ totalPages }}</span>
                  <v-btn :disabled="currentPage === totalPages" @click="currentPage++" small plain>
                    <v-icon color="black" small class="mr-2">
                      mdi-arrow-right
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col
                    cols="12"
                    xl="3"
                    lg="3"
                    md="3"
                    sm="6"
                    class="pa-3"
                    v-for="(resource, index) in paginatedResources"
                    :key="'resource-' + index"
                  >
                    <v-hover v-slot="{ hover }">
                      <v-card
                        class="d-flex justify-center align-center"
                        elevation="3"
                        style="border-radius: 24px; height: 100%;"
                        :class="{ 'on-hover': hover }"
                        @click="redirect(resource)"
                      >
                        <v-card-text>
                          <v-row align="center">
                            <v-col cols="12" xl="6" lg="12" md="12" sm="12" align="center">
                              <v-img
                                v-if="resource.logo"
                                height="120px"
                                max-width="80%"
                                contain
                                v-bind:src="resource.logo"
                                :style="{
                                  borderTopLeftRadius: '24px',
                                  borderTopRightRadius: '24px',
                                }"
                              ></v-img>
                              <v-img
                                v-else
                                height="120px"
                                max-width="80%"
                                contain
                                :src="require('@/assets/img/blur.jpg')"
                              />
                            </v-col>
                            <v-col cols="12" xl="6" lg="12" md="12" sm="12" align="center">
                              <div class="mt-0 pt-0">
                                <span class="text-bold black--text">
                                  {{ resource.name }}
                                </span>
                              </div>
                              <div class="mt-0 pt-0">
                                <span class="text-bold">
                                  {{ resource.orderable ? 'Orderable' : 'Non Orderable' }}
                                </span>
                              </div>
                              <div>
                                <v-chip
                                  depressed
                                  rounded
                                  small
                                  color="blue"
                                  class="white--text font-weight-bold"
                                >
                                  {{ resource.label }}
                                </v-chip>
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-hover>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <!-- Order Service Dialog -->
            <v-dialog v-model="orderServiceDialog" max-width="1000px" persistent>
              <v-card
                class="py-4 px-5 px-sm-16 px-md-16 px-lg-16 px-xl-16 py-sm-8 py-md-8 py-lg-8 py-xl-8"
              >
                <v-card-title class="px-0 py-0">
                  <v-row class="mx-0 px-2" align="center">
                    <v-col cols="11" class="text-center d-flex justify-center align-center">
                      {{ !ordersPending ? 'Order Service' : 'Order Status' }}
                    </v-col>
                    <v-col cols="1" class="pl-0">
                      <v-btn fab small text @click="orderServiceDialog = false">
                        <v-icon color="neutral500">
                          mdi-close
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-title>

                <v-divider class="custom-divider"></v-divider>

                <v-card-text v-if="!ordersPending" class="mt-10">
                  <v-form ref="orderServiceForm" v-model="valid" :lazy-validation="false">
                    <v-row>
                      <v-col cols="12" class="pt-0">
                        <p class="label-info">
                          Payments and pricing must by discussed directly with the service provider
                        </p>
                      </v-col>
                      <v-col cols="12" class="pt-0">
                        <v-menu
                          v-model="dateFromMenu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              v-model="serviceOrder.dateFrom"
                              label="Date From"
                              append-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              class="required"
                              :rules="requiredRule()"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="serviceOrder.dateFrom"
                            @input="dateFromMenu = false"
                            color="rgba(157, 87, 244, 1)"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" class="pt-0">
                        <v-menu
                          v-model="dateToMenu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              v-model="serviceOrder.dateTo"
                              label="Date To"
                              append-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              class="required"
                              :rules="requiredRule()"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="serviceOrder.dateTo"
                            @input="dateToMenu = false"
                            color="rgba(157, 87, 244, 1)"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" class="pt-0">
                        <label>Use Case*</label>
                        <v-textarea
                          v-model="serviceOrder.useCase"
                          :placeholder="'Use Case'"
                          outlined
                          clearable
                          :rules="requiredRule()"
                          class="required"
                        ></v-textarea>
                      </v-col>
                      <v-col cols="12" class="pt-0">
                        <label>Additional Prerequisites</label>
                        <p class="label-info">{{ $t('order-additional-info-text') }}</p>
                        <v-textarea
                          v-model="serviceOrder.additionalInformation"
                          :placeholder="'Additional Prerequisites'"
                          outlined
                          clearable
                        ></v-textarea>
                      </v-col>
                      <v-col cols="12" class="pt-0">
                        <v-checkbox
                          :rules="requiredRule()"
                          label="I acknowledge that the order adheres to the service’s prerequisites"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
                <v-card-text v-else>
                  <v-row>
                    <v-col cols="12">
                      <v-data-table
                        :headers="headersOrder"
                        :items="orders"
                        hide-default-footer
                        disable-pagination
                      >
                        <template v-slot:item.orderDate="{ item }">
                          <span>
                            {{ formatDateLocaleAE(item.createdTimestamp) }}
                          </span>
                        </template>
                        <template v-slot:item.status="{ item }">
                          <v-chip :color="getOrderColor(item.status.id)">
                            {{
                              item.status.description +
                                (item.statusExplicit ? ' - ' + item.statusExplicit : '')
                            }}
                          </v-chip>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions v-if="!ordersPending">
                  <v-row style="width: 100%">
                    <v-col cols="6">
                      <v-btn
                        block
                        depressed
                        rounded
                        large
                        class="neutral800--text font-weight-bold"
                        color="neutral"
                        outlined
                        @click="cancelServiceOrder"
                        >{{ $t('cancel') }}
                      </v-btn>
                    </v-col>
                    <v-col cols="6">
                      <v-btn
                        :disabled="!valid"
                        block
                        depressed
                        rounded
                        large
                        class="white--text font-weight-bold"
                        color="black"
                        @click="submitServiceOrder"
                        >{{ $t('submit') }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <!-- Non registered dialog -->
            <v-dialog v-model="modalLogIn" max-width="1000px">
              <v-card
                class="py-4 px-5 px-sm-16 px-md-16 px-lg-16 px-xl-16 py-sm-8 py-md-8 py-lg-8 py-xl-8"
              >
                <v-card-title class="px-0 py-0">
                  <v-row class="mx-0 px-2" align="center">
                    <v-col cols="11" class="text-center d-flex justify-center align-center">
                      This action requires authentication
                    </v-col>
                    <v-col cols="1" class="pl-0">
                      <v-btn fab small text @click="modalLogIn = false">
                        <v-icon color="neutral500">
                          mdi-close
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-divider class="mt-1 mb-6 my-sm-6 my-lg-6 my-xl-6 my-md-6"></v-divider>
                <v-card-text class="pa-0 text-center">
                  Only authenticated users are allowed to perform this action. Please
                  <router-link :to="{ name: 'OverviewService', params: { id: $route.params.id } }"
                    ><span class="font-weight-bold">Log In</span></router-link
                  >
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import util from '@/mixins/util.js';
import EventBus from '@/helpers/event-bus.js';

export default {
  name: 'PublicOverviewService',
  mixins: [util],
  data() {
    return {
      service: {
        logoUrlPublic: null,
        picture: null,
        views: null,
        nonRegisteredViews: null,
        name: '',
        email: '',
        description: '',
        orderable: false,
        provider: {
          name: '',
          hostingInstitution: '',
          id: '',
        },
        tags: [],
        basicInfo: {
          prerequisites: '',
          webpage: '',
          tagline: '',
          useCases: [],
        },
        classificationInfo: {
          domains: [],
          categories: [],
          accessModes: [],
          accessTypes: [],
          targetUsers: [],
        },
        contactInfo: {
          firstname: '',
          lastname: '',
          email: '',
          phone: '',
        },
        managementInfo: {
          serviceLevel: '',
        },
        pricingInfo: {
          paymentModel: '',
          pricing: '',
        },
        additionalInfo: {
          helpDeskEmail: '',
          standards: [],
          userManual: null,
          termsOfUse: null,
        },
      },
      isFavorite: false,
      tab: null,
      letters: '',
      resources: [],
      currentPage: 1,
      itemsPerPage: 8,
      marketplaceServicesViewAll: '',
      statusIds: [],
      orders: [],
      orderServiceDialog: false,
      valid: false,
      dateFromMenu: false,
      dateToMenu: false,
      serviceOrder: {
        useCase: '',
        dateFrom: null,
        dateTo: null,
        additionalInformation: '',
      },
      isVerified: {
        verified: false,
      },
      modalLogIn: false,
      serviceSearchMarketplaceQuery: '',
    };
  },
  mounted() {
    this.getService();

    this.marketplaceServicesViewAll = this.$route.query.marketplaceServicesViewAll;
    this.serviceSearchMarketplaceQuery = this.$route.query.serviceSearchMarketplace;
    this.getOrders();
  },
  beforeUpdate() {
    const { firstname, lastname } = this.service.contactInfo;
    this.letters = '';

    if (lastname && firstname) {
      this.letters = lastname.charAt(0) + firstname.charAt(0);
    }
  },
  computed: {
    orderDisabled() {
      return !this.service.orderable || !['researcher'].includes(this.$store.getters.roles);
    },
    ordersPending() {
      return this.statusIds.some(status =>
        ['REQUESTED', 'ACCEPTED_BY_PROVIDER', 'ACCEPTED_BY_RESEARCHER'].includes(status),
      );
    },
    totalPages() {
      return Math.ceil(this.resources.length / this.itemsPerPage);
    },
    paginatedResources() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.resources.slice(start, end);
    },
    managementTab() {
      if (this.service.managementInfo.serviceLevel) {
        return true;
      } else {
        return false;
      }
    },
    contactTab() {
      if (this.service.contactInfo.email) {
        return true;
      } else {
        return false;
      }
    },
    basicInfoTab() {
      if (
        this.service.basicInfo.prerequisites ||
        this.service.basicInfo.useCases.length ||
        this.service.basicInfo.webpage ||
        this.service.basicInfo.tagline
      ) {
        return true;
      } else {
        return false;
      }
    },
    classificationTab() {
      if (
        this.service.classificationInfo.domains.length ||
        this.service.classificationInfo.categories.length ||
        this.service.classificationInfo.accessModes.length ||
        this.service.classificationInfo.accessTypes.length ||
        this.service.classificationInfo.targetUsers.length
      ) {
        return true;
      } else {
        return false;
      }
    },
    additionalInfoTab() {
      if (
        this.service.additionalInfo.helpDeskEmail ||
        this.service.additionalInfo.standards.length ||
        this.service.userManual ||
        this.service.additionalInfo.termsOfUse
      ) {
        return true;
      } else {
        return false;
      }
    },
    pricingTab() {
      if (this.service.pricingInfo.pricing || this.service.pricingInfo.paymentModel) {
        return true;
      } else {
        return false;
      }
    },
    headersOrder() {
      let headers = [
        { text: 'Order Date', value: 'orderDate', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Use Case', value: 'useCase', sortable: true },
        { text: 'Additional Prerequisites', value: 'additionalInformation', sortable: true },
      ];
      return headers;
    },
  },
  methods: {
    goBack() {
      if (this.marketplaceServicesViewAll && this.$route.query.fromTable) {
        const marketplaceServicesViewAll = true;
        const selectedCatalogue = 'Browse the Catalogue of Services';
        let routePath = '';
        routePath = '/public-catalogue-marketplace/services';
        const fromTable = this.$route.query;
        this.$router.push({
          path: routePath,
          query: { selectedCatalogue, marketplaceServicesViewAll, ...fromTable },
        });
      } else if (this.marketplaceServicesViewAll && this.$route.query.filters) {
        const marketplaceServicesViewAll = true;
        const selectedCatalogue = 'Browse the Catalogue of Services';
        let routePath = '';
        routePath = '/public-catalogue-marketplace/services';
        const filters = this.$route.query;
        this.$router.push({
          path: routePath,
          query: { selectedCatalogue, marketplaceServicesViewAll, ...filters },
        });
      } else if (this.serviceSearchMarketplaceQuery && this.$route.query.filters) {
        localStorage.setItem('tabIndex', 0);
        const filters = this.$route.query;
        this.$router.push({
          name: 'PublicSearchMarketplace',
          query: filters,
        });
      } else {
        this.$router.go(-1);
      }
    },
    getService() {
      EventBus.$emit('waiting', true);
      const id = this.$route.params.id;

      this.axios
        .get(`/api/v1/resources/${id}`)
        .then(response => {
          console.log('Get Service', response.data);
          this.isFavorite = response.data.isFavorite;

          this.service.logoUrlPublic = response.data.logoUrlPublic;
          this.service.nonRegisteredViews = response.data.viewsNonRegistered;
          this.service.picture = response.data.picture;
          this.service.email = response.data.email;
          this.service.views = response.data.views;
          this.service.name = response.data.name;
          this.service.description = response.data.description;
          this.service.provider = {
            name: response.data.provider.name,
            hostingInstitution: response.data.provider.hostingInstitution,
            id: response.data.provider.id,
          };
          this.service.tags = response.data.tags;
          this.service.orderable = response.data.orderable;
          this.service.basicInfo = {
            prerequisites: response.data.prerequisites,
            webpage: response.data.webpage,
            tagline: response.data.tagline,
            useCases: response.data.useCases,
          };
          this.service.classificationInfo = {
            domains: response.data.scientifics,
            categories: response.data.categories,
            accessModes: response.data.accessModes,
            accessTypes: response.data.accessTypes,
            targetUsers: response.data.targets,
          };

          const verifiedContact = response.data.publicContacts?.find(
            contact => contact.verified === true,
          );

          this.isVerified.verified = verifiedContact ? verifiedContact.verified : false;

          this.service.contactInfo = {
            firstname: verifiedContact?.firstname,
            lastname: verifiedContact?.lastname,
            email: verifiedContact?.email,
            phone: verifiedContact?.phone,
            verified: verifiedContact ? verifiedContact.verified : false,
          };
          // this.service.contactInfo = {
          //   firstname:
          //     response.data.publicContactsVerified &&
          //     response.data.publicContactsVerified.length > 0
          //       ? response.data.publicContactsVerified[0].firstname
          //       : '-',
          //   lastname:
          //     response.data.publicContactsVerified &&
          //     response.data.publicContactsVerified.length > 0
          //       ? response.data.publicContactsVerified[0].lastname
          //       : '-',
          //   email:
          //     response.data.publicContactsVerified &&
          //     response.data.publicContactsVerified.length > 0
          //       ? response.data.publicContactsVerified[0].email
          //       : '-',
          //   phone:
          //     response.data.publicContactsVerified &&
          //     response.data.publicContactsVerified.length > 0
          //       ? response.data.publicContactsVerified[0].phone
          //       : '-',
          // };
          this.service.managementInfo = {
            serviceLevel: response.data.serviceLevel,
          };
          this.service.pricingInfo = {
            paymentModel: response.data.paymentModel
              ? response.data.paymentModel.replace(/<\/?[^>]+>/g, '')
              : '',
            pricing: response.data.pricing ? response.data.pricing.replace(/<\/?[^>]+>/g, '') : '',
          };
          this.service.additionalInfo = {
            helpDeskEmail: response.data.helpDeskEmail,
            standards: response.data.standards,
            userManual: response.data.userManual,
            termsOfUse: response.data.termsOfUse,
          };
          this.getOtherResources(this.service);
        })
        .catch(error => {
          console.error('Error fetching service data:', error);
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    getOtherResources(service) {
      EventBus.$emit('waiting', true);

      const providerId = service.provider.id;
      const excludedId = this.$route.params.id;

      this.axios
        .get(`api/v1/equipment/other-resources`, {
          params: {
            providerId,
          },
        })
        .then(response => {
          console.log('Response data from Other Resources:', response.data);

          this.resources = response.data.filter(
            resource => resource.id !== parseInt(excludedId, 10),
          );

          this.currentPage = 1;
        })
        .catch(error => {
          console.error('Error fetching other resources:', error);
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    addFavorite() {
      const id = this.$route.params.id;

      EventBus.$emit('waiting', true);

      this.axios
        .post(`/api/v1/favorites/${id}`)
        .then(() => {
          EventBus.$emit('snackbar', {
            text: 'Favorite added successfully',
          });
          this.isFavorite = true;
        })
        .catch(error => {
          EventBus.$emit('snackbar', {
            text: error.response.data,
            color: 'warning',
          });
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    removeFavorite() {
      const id = this.$route.params.id;

      EventBus.$emit('waiting', true);

      this.axios
        .delete(`/api/v1/favorites/${id}`)
        .then(() => {
          EventBus.$emit('snackbar', {
            text: 'Favorite removed successfully',
          });
          this.isFavorite = false;
        })
        .catch(error => {
          EventBus.$emit('snackbar', {
            text: error.response.data,
            color: 'warning',
          });
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    handleServiceLevelClick() {
      const url = this.service.managementInfo.serviceLevel;
      if (url) {
        window.open(url, '_blank');
      } else {
        console.log('No valid URL found');
      }
    },
    downloadUserManual(file) {
      const id = this.$route.params.id;
      const filePath = `api/v1/resources/${id}/file/${file}?field=userManual`;

      this.axios
        .get(filePath, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], {
            type: response.headers['content-type'],
          });

          const fileURL = URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.href = fileURL;
          a.download = file;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);

          URL.revokeObjectURL(fileURL);
        })
        .catch(error => {
          console.error('Error fetching file:', error);
        });
    },
    downloadTermsOfUse(file) {
      const id = this.$route.params.id;
      const filePath = `api/v1/resources/${id}/file/${file}?field=termsOfUse`;

      this.axios
        .get(filePath, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], {
            type: response.headers['content-type'],
          });

          const fileURL = URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.href = fileURL;
          a.download = file;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);

          URL.revokeObjectURL(fileURL);
        })
        .catch(error => {
          console.error('Error fetching file:', error);
        });
    },
    redirect(resource) {
      const id = resource.id;
      const label = resource.label;

      if (id && label === 'Service' && !this.$store.getters.roles) {
        this.$router.push({ name: 'PublicOverviewService', params: { id: id } });
        this.$nextTick(() => {
          this.getService();
        });
      }

      if (id && label === 'Equipment' && !this.$store.getters.roles) {
        this.$router.push({ name: 'PublicOverviewEquipment', params: { id: id } });
      }

      if (id && label === 'Patent' && !this.$store.getters.roles) {
        this.$router.push({ name: 'PublicOverviewPatent', params: { id: id } });
      }
    },
    getOrders() {
      const id = this.$route.params.id;
      if (this.$store.getters.roles === 'researcher') {
        this.axios
          .get(`api/v1/orders?resourceId=${id}`)
          .then(response => {
            this.orders = response.data.content;
            this.statusIds = this.orders.map(order => order.status?.id);
            console.log('Get Orders:', this.orders);
          })
          .catch(error => {
            console.error('Error fetching data:', error);
          });
      }
    },
    cancelServiceOrder() {
      this.serviceOrder.useCase = '';
      this.serviceOrder.dateFrom = null;
      this.serviceOrder.dateTo = null;
      this.serviceOrder.additionalInformation = '';
      this.orderServiceDialog = false;
    },
    submitServiceOrder() {
      EventBus.$emit('waiting', true);

      const id = this.$route.params.id;

      const payload = {
        resource: {
          id: id,
          name: this.service.name,
        },
        fromDate: this.serviceOrder.dateFrom,
        toDate: this.serviceOrder.dateTo,
        useCase: this.serviceOrder.useCase,
        additionalInformation: this.serviceOrder.additionalInformation,
      };

      this.axios
        .post('/api/v1/orders', payload)
        .then(response => {
          console.log('Order submitted successfully:', response.data);
          EventBus.$emit('snackbar', {
            text: 'Order successfully submitted',
          });
          this.orderServiceDialog = false;
          this.statusId = 'REQUESTED';
          this.getOrders();
        })
        .catch(error => {
          console.error('There was an error submitting the order:', error);
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
  },
};
</script>

<style>
.custom-divider {
  padding: 5px 0;
  margin: 25px 35px 0px 35px;
  border-top-width: 2px;
  border-top-style: solid;
  border-top-color: rgba(195, 194, 199, 1);
}

#overview-service-tab .v-toolbar {
  background: rgba(250, 250, 250, 1) !important;
  border-bottom: 2px solid #f4f2f9 !important;
}

#overview-service-tab .custom-app-bar {
  background-color: rgba(0, 0, 0, 0) !important;
  border-bottom: none !important;
}
</style>
